<div class="cd-section" id="features" style="background-color: white;">
    <div class="container">
      <div class="features-2">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title-difference">How Do We Help?</h2>
            <h5 class="description" style="font-size: 20px;">While there are many legacy solutions on the market,
              RegScale stands out as the future of Continuous Compliance Automation based on our:</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="info info-horizontal">
              <div class="icon icon-info">
                <i class="fas fa-car"></i>
              </div>
              <div class="description">
                <h4 class="info-title">Compliance Concierge</h4>
                <p class="difference" style="font-size: 20px;">We took the complexity out of generating compliance artifacts with a wizard-driven experience
                  (Next->Next->Finish) to help you every step of the way. </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info info-horizontal">
              <div class="icon icon-danger">
                <i class="fas fa-code-branch"></i>
              </div>
              <div class="description">
                <h4 class="info-title">DevOps</h4>
                <p class="difference" style="font-size: 20px;">We built a compliance Switzerland with 100+ Open REST APIs to ingest and export data with no
                  vendor lock-in; all based on open standards.</p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info info-horizontal">
              <div class="icon icon-success">
                <i class="fas fa-clipboard-list"></i>
              </div>
              <div class="description">
                <h4 class="info-title">Audits and Evidence</h4>
                <p class="difference" style="font-size: 20px;">Schedule audits, document associated issues, attach evidence, and track corrective actions to closure
                  in a modern collaboration environment.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
